module.exports = __webpack_public_path__ + "media/images/tavour_icon_100-0cb1a5990cd4e6a8637f21b0789f7dc1.png";